import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from '@mui/material/FormControl';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import WeekPicker from "../../TimesheetItems/WeekPicker";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import MUIDataTable from 'mui-datatables';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';
import { Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import EditSummaryDialog from "../../AdminItems/EditDialogue/EditSummary";
import Tooltip from '@mui/material/Tooltip';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { makeStyles } from "@mui/styles";

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

export default function ReportTimeEntryUnPaid({ start, end, poid = 0 }) {
	const [refresh, setRefresh] = React.useState(false);
	const [open, setOpen] = React.useState(false);
	const [StartDate, setStartDate] = React.useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'));
	const [EndDate, setEndDate] = React.useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'));
	const [dataSet, setDataSet] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [permission, permissionSet] = React.useState([]);
    const [taskVariable, setTaskVariable] = React.useState([]);
    const [customColumns, setCustomColumns] = React.useState([]);
    const [expand, setExpand] = React.useState("summary");
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);
    const [addCols, setAddCols] = React.useState(true);


    const classes = pageStyles();

    const initialValues = {
        POID: ''
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
            
    })

    React.useEffect(() => {
    	checkAuthentication();
        if (refresh) {
              if (start) setStartDate(start);
       		  if (end) setEndDate(end);
            
            fetch(`/api/User/Permission`)
                .then(res => res.json())
                .then(json => permissionSet(json))

            fetch(`/api/taskVariable/dropdown`)
                .then(res => res.json())
                .then(json => setTaskVariable(json))
            setRefresh(false);
        }
        if (dataSet.length && addCols) {
            addColumn(taskVariable)
        }
    })
    
	const convertDates = (json) => {
		json.forEach(eachObj => {
			eachObj.DayOf = moment.utc(eachObj.DayOf).format("MM/DD/YYYY");
			eachObj.WeekOf = moment.utc(eachObj.WeekOf).format("MM/DD/YYYY");
			if (eachObj.Rate) {
				const byteArray = new Uint8Array(eachObj.Rate.data);
				const textDecoder = new TextDecoder();
				const res = textDecoder.decode(byteArray);
				const r = parseFloat(res).toFixed(2);
				eachObj.Rate = r;
			}
		});
		if (json.length===0){
			setOpenLogs(false);
			setAlertText("No Time Entries available for the time selected");
			setAlert(true);
		}
		setIsLoading(false);
		setDataSet(json);
	};
	
	const handleStatus = (status) => {
		if (status == 0) {
			return ("Pending");
		}
		if (status == 1) {
			return ("Approved");
		}
		if (status == -1) {
			return ("Rejected");
		}
	};
    
    const getDataSet = async () => {
        logger(`/api/Reports/time_entry_unpaid/${moment(StartDate).format('YYYY-MM-DD')}/${moment(EndDate).format('YYYY-MM-DD')}`)
        await fetch(`/api/Reports/time_entry_unpaid/${moment.utc(StartDate).format('YYYY-MM-DD')}/${moment.utc(EndDate).format('YYYY-MM-DD')}`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                logger('output', json)
                convertDates(json)
                setIsLoading(false);
                setRefresh(true);
            })
    }

    const handleGenerate = () => {
		setOpenLogs(true);
        getDataSet();
        setIsLoading(true);
    };
    
     const handleAlertClose = () => {
        setAlert(false);
    };

	const addColumn = (list) => {
		logger("addColumn", list);
		const editableColumns = [
			/*{
				name: "Actions",
				options: {
					filter: false,
					sort: false,
					empty: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						return (
							<div>
								{logger(dataSet[dataIndex])}
								{dataSet[dataIndex].WeekOf !== moment.utc(null).format("MM/DD/YYYY") ? <EditSummaryDialog key={rowIndex}
									callRefresh={callRefresh}
									handleEditCallback={handleEditCallback}
									permission={permission}
									data={{ Name: dataSet[dataIndex].Name, UserID: dataSet[dataIndex].UserID, WeekOf: dataSet[dataIndex].WeekOf }} /> : "No Time Entered"}
							</div>
						);
					}
				}
			},*/
			{
				name: "DayOf",
				label: "Date",
				options: {
					filter: false,
					sort: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						return (
							dataSet[dataIndex].DayOf
                            //moment.utc(dataSet[dataIndex].DayOf).format("MM/DD/YYYY")
                        );
                    }
                }
            },
            {
                name: "WeekOf",
                label: "WeekOf",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        return (
                            //moment.utc(dataSet[dataIndex].WeekOf).format("MM/DD/YYYY")
                            dataSet[dataIndex].WeekOf
                        );
                    }
                }
            },
            {
                name: "Name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Lab_Name",
                label: "Program",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Project",
                label: "Project",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },

			{
				name: "Task",
				label: "Task",
				options: {
					filter: true,
					sort: true,
					//    position: "sticky",
				}
			},

			{
				name: "Hours",
				label: "Hours",
				options: {
					filter: false,
					sort: true,
					//    position: "sticky",
				}
			},
			{
				name: "VerifyStatus",
				label: "Status",
				options: {
					filter: false,
					sort: false,
					customBodyRenderLite: (dataIndex) => {
						const status = dataSet[dataIndex].VerifyStatus;
						let statusText = handleStatus(status);
						let style = {};
						let tooltip = "";

						if (status === 0 || status === -1) {
							// Pending
							style = { color: "red" };
							tooltip = "Not Yet Approved";
						} else if (status === 1) {
							// Approved
							style = { color: "black" };
							tooltip = "Approved";
						}

						return (
							<Tooltip title={tooltip}>
								<div style={style}>
									{statusText}
								</div>
							</Tooltip>
						);
					}
				}
			},
			{
				name: "FlagType",
				label: "FlagType",
				options: {
					sort: true,
					filter: true
				}
			},
			{
				name: "Position_Name",
				label: "Position",
				options: {
					filter: false,
					sort: true,
					print: false,
					//    position: "sticky",
				}
			},
			{
				name: "Position_FullName",
				label: "FullPosition",
				options: {
					filter: false,
					sort: true,
					display: false,
					//    position: "sticky",
				}
			},

			{
				name: "PO",
				label: "PO",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`dataSet[dataIndex]`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>Non-Billable</>
							);
						} else{
							return (
								<>Billable</>
							);
						}
					}
				}
			},
		];
		if (expand==="detailed") {
			list.forEach((e) => {
				editableColumns.push({
					name: `${e.Name}`,
					label: `${e.Name}`,
					options: {
						filter: true,
						sort: true,
					}
				})
			})
		}else if(expand==="summary"){
			editableColumns.push(
				{
	            name: "TaskVariables",
	            label: "TaskVariables",
					options: {
						filter: false,
						sort: false,
	                customBodyRender: (value, tableMeta, updateValue) => {
						var rowIndex = tableMeta.rowIndex;
						
						return list.map((item, idx) => {
							var columnName = item.Name;
							var data = dataSet[rowIndex];
							var value = data[columnName]?data[columnName]:'';
							return (data[columnName] &&
                                <React.Fragment key={idx}>
                                    {columnName + ': ' + value}
                                    <br />
                                </React.Fragment>
                            );
						});
	                }
	            }
	        })
		}

		setAddCols(false);
		setCustomColumns(editableColumns);
	};

	const handleClickOpen = () => {
		setRefresh(true)
		setOpen(true)
		setExpand("summary");
	};

	const handleStartDate = (Data) => {
		setStartDate(Data.target.value);
		logger(Data.target.value);
	}

	const handleEndDate = (Data) => {
		setEndDate(Data.target.value);
		logger(Data.target.value);
	}
	
	const handleRadioButton = (event) => {
		setExpand(event.target.value);
	}

	const handleClose = () => {
		//   setPOChoices(0);
		setOpen(false);
	};

	const handleOpenForLogs = () => {
		setOpenLogs(true)
	};

	const handleCloseForLogs = () => {
		setDataSet([])
		setCustomColumns([])
		setOpenLogs(false);
		setAddCols(true);
	};

	const callRefresh = () => {
		setRefresh(true);
	};

	const handleEditCallback = (childData) => {
		fetch("/api/Summary", {
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				"ApprovalAll": childData.approvalAll,
				"Week": childData.Week
			})
		})

		logger(childData)
		//   window.location.reload();
		setRefresh(true)
	};

	const getSavedRowsPerPage = () => {
		const savedValue = localStorage.getItem('rowsPerPage');
		return savedValue ? parseInt(savedValue) : 100; // Default value
	}
	// Save to local storage
	const saveRowsPerPage = (value) => {
		localStorage.setItem('rowsPerPage', value.toString());
	}

	const initialRowsPerPage = getSavedRowsPerPage();

	const options = {
		filter: true,
		filterType: 'dropdown',
		responsive: 'vertical',
		fixedHeader: true,
		fixedSelectColumn: false,
		tableBodyHeight: "400px",
		tableBodyMaxHeight: "1000px",
		rowsPerPage: initialRowsPerPage,
		responsive: 'standard',
		rowsPerPageOptions: [10, 20, 50, 100],
		textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
		},
		selectableRows: 'none',
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				return customBodyForExcelReport({ data: data, headers: headers} );
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({ rows: rows, headers: headers, filename: 'TimeEntry.xlsx' })
			return false;
		}

    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                    Report UnPaid Time Entry
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            //onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                                Report UnPaid Time Entry
                                            </Typography>
                                            {/*<FormControl>
											  <RadioGroup
											    aria-labelledby="radio-buttons-group-label"
											    name="radio-buttons-group"
											    value={expand}
											    onChange={handleRadioButton}
											    row
											  >
											  		<Tooltip title="Shows Rime Entry Task Variables">
													<FormControlLabel value="summary" control={<Radio sx={{
														'& .MuiSvgIcon-root': {
															color: "white"
														},
													}} />} label="Summary" />
													 </Tooltip>
													 <Tooltip title="Shows Time Entry detailed Task Variables">
													<FormControlLabel value="detailed" control={<Radio sx={{
														'& .MuiSvgIcon-root': {
															color: "white"
														},
													}} />} label="Detailed" />
													 </Tooltip>
											  </RadioGroup>
											</FormControl>*/}
                                            <Button color="inherit" onClick={handleGenerate}>
                                            Generate
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                    <DialogTitle>Report UnPaid Time Entry:</DialogTitle>            
                                 <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleStartDate}
                                                value={StartDate}
                                                label="Start Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='end'
                                                id="outlined-EndDate"
                                                type="date"
                                                onChange={handleEndDate}
                                                value={EndDate}
                                                label="End Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                </div>
                            </Form>
                        )}
                        </Formik>
                        <Dialog open={openLogs} onClose={handleCloseForLogs} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                            <DialogContent >
                                <Box>

                                    <MUIDataTable
                                        title={

                                            <Typography variant="h6" style={{ color: "white" }}>
                                                <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
                                                Report UnPaid Time Entry
                                                <Button component={Link} color="inherit" to="/Summary">Go to Summary</Button>
                                            </Typography>
                                        }
                                        data={isLoading ? [] :dataSet}
                                        columns={customColumns}
                                        options={isLoading?muiLoaderOptions(options, isLoading):options}
                                    />
                                </Box>
                            </DialogContent>
                        </Dialog>
                          <Dialog
			                open={LockedAlert}
			                onClose={handleAlertClose}
			                aria-labelledby="L&P Lock"
			                aria-describedby="Time Period work"
			            >
			                <DialogTitle id="Time Entry">
			                    {"Alert"}
			                </DialogTitle>
			                <DialogContent>
			                    <DialogContentText id="alert-dialog-description">
			                        {AlertText}
			                    </DialogContentText>
			                </DialogContent>
			                <DialogActions>
			                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
			                </DialogActions>
			            </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 